import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-statistics-metric-card',
  templateUrl: './statistics-metric-card.component.html',
  styleUrls: ['./statistics-metric-card.component.scss']
})
export class StatisticsMetricCardComponent implements OnInit {
  @Input() title: string = '';
  @Input() value: number | string = 0;
  @Input() subtitle?: string;
  @Input() icon?: string;
  @Input() color: 'primary' | 'success' | 'warning' | 'danger' | 'info' = 'primary';
  @Input() trend?: {
    value: number;
    direction: 'up' | 'down' | 'neutral';
    label?: string;
  };
  @Input() loading: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  get colorClasses(): string {
    const colorMap = {
      primary: 'bg-gradient-to-br from-blue-50 to-blue-100/50 border-blue-300/60 text-blue-800',
      success: 'bg-gradient-to-br from-green-50 to-green-100/50 border-green-300/60 text-green-800',
      warning: 'bg-gradient-to-br from-yellow-50 to-yellow-100/50 border-yellow-300/60 text-yellow-800',
      danger: 'bg-gradient-to-br from-red-50 to-red-100/50 border-red-300/60 text-red-800',
      info: 'bg-gradient-to-br from-indigo-50 to-indigo-100/50 border-indigo-300/60 text-indigo-800'
    };
    return colorMap[this.color] || colorMap.primary;
  }

  get iconColorClasses(): string {
    const colorMap = {
      primary: 'text-blue-600',
      success: 'text-green-600',
      warning: 'text-yellow-600',
      danger: 'text-red-600',
      info: 'text-indigo-600'
    };
    return colorMap[this.color] || colorMap.primary;
  }

  get trendIcon(): string {
    if (!this.trend) return '';
    if (this.trend.direction === 'up') return 'pi pi-arrow-up';
    if (this.trend.direction === 'down') return 'pi pi-arrow-down';
    return 'pi pi-minus';
  }

  get trendColor(): string {
    if (!this.trend) return '';
    if (this.trend.direction === 'up') return 'text-green-600';
    if (this.trend.direction === 'down') return 'text-red-600';
    return 'text-gray-600';
  }
}

